import React from 'react';
import './Loadingbar.css';

function LoadingBar() {
  return (
    <div className="spinner-container">
      <div className="spinner" />
    </div>
  );
}

export default LoadingBar;
